import type { ReactNode } from "react";

type BadgeTone =
  | "gold"
  | "dark"
  | "outline"
  | "soft"
  | "neutral"
  | "rose"
  | "lilac"
  | "clinic"
  | "beige"
  | "terracotta";

const toneClasses: Record<BadgeTone, string> = {
  gold: "bg-accent-500 text-primary-950",
  dark: "bg-primary-500 text-background-50",
  outline: "border border-accent-400/70 bg-background-50/85 text-accent-900 backdrop-blur-sm",
  soft: "bg-accent-100 text-accent-900",
  neutral: "border border-secondary-200 bg-background-50/90 text-foreground-700 backdrop-blur-sm",
  rose: "tone-rose-surface",
  lilac: "tone-lilac-surface",
  clinic: "tone-clinic-surface",
  beige: "tone-beige-surface",
  terracotta: "tone-terracotta-surface",
};

type BadgeProps = {
  children: ReactNode;
  tone?: BadgeTone;
  icon?: string;
  className?: string;
};

export default function Badge({ children, tone = "soft", icon, className = "" }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 font-label text-[10px] font-semibold uppercase tracking-[0.14em] ${toneClasses[tone]} ${className}`}
    >
      {icon ? <i className={`${icon} text-xs`} /> : null}
      {children}
    </span>
  );
}